import React from "react";
import {
  SELECTED_ELEMENT_COLOR,
  defaultObjectSizes,
  OBJECT_TYPES,
} from "../configuratorConstants";
import { ReactComponent as HeaterIcon } from "../../Assets/heater.svg";

const HeaterRenderer = ({
  element,
  scale,
  isSelected,
  wallThickness,
  placementSideFactor,
  orientation,
  jointWidth,
}) => {
  const defaults = defaultObjectSizes[OBJECT_TYPES.HEATER];
  const elementVisualWidthM = element.width || defaults.width;
  const elementPlanDepthM = element.depth || defaults.depth;

  const elementVisualWidthPx = elementVisualWidthM * scale;
  const elementPlanDepthPx = elementPlanDepthM * scale;

  const wallThicknessPx = wallThickness * scale;

  // Позиционируем нагреватель вплотную к стене
  const offset = placementSideFactor * (wallThicknessPx / 2 + elementPlanDepthPx / 2);

  // Определяем правильную ориентацию и позиционирование
  let rotationAngle;

  if (orientation === 'v') {
    // Для вертикальных стен: правильная ориентация
    rotationAngle = placementSideFactor === 1 ? 90 : -90;
  } else {
    // Для горизонтальных стен: поворачиваем чтобы спина была к стене
    rotationAngle = placementSideFactor === 1 ? 90 : -90;
  }

  const groupTransform = `translate(0, ${offset}) rotate(${rotationAngle})`;

  const iconStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.2)" : "#fff",
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "#4B5563",
    strokeWidth: isSelected ? 1.5 : 1,
    pointerEvents: "none",
  };

  return (
    <g transform={groupTransform}>
      <rect
        x={-elementVisualWidthPx / 0.75}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx}
        height={elementPlanDepthPx}
        fill="rgba(0,0,0,0)"
        style={{ cursor: 'pointer', pointerEvents: 'all' }}
      />

      <HeaterIcon
        x={-elementVisualWidthPx / 0.75}
        y={-elementPlanDepthPx / 2}
        width={elementVisualWidthPx}
        height={elementPlanDepthPx}
        style={iconStyle}
        preserveAspectRatio="xMidYMid meet"
      />
    </g>
  );
};
export default React.memo(HeaterRenderer);
